let appRouter = null;
const EDITOR_RETURN_ROUTE_KEY = 'jx_editor_return_route';
let memoryEditorReturnRoute = '';

export function registerAppRouter(router) {
  appRouter = router;
}

export function getAppRouter() {
  return appRouter;
}

export function pushRoute(path) {
  if (!appRouter) return;
  if (appRouter.currentRoute.value.fullPath === path) return;
  appRouter.push(path);
}

export function replaceRoute(path) {
  if (!appRouter) return;
  if (appRouter.currentRoute.value.fullPath === path) return;
  appRouter.replace(path);
}

export function setEditorReturnRoute(routePath) {
  if (!routePath || typeof routePath !== 'string') return;
  if (routePath === '/editor' || routePath.startsWith('/editor?') || routePath.startsWith('/login') || routePath === '/') {
    return;
  }
  memoryEditorReturnRoute = routePath;
  if (typeof sessionStorage !== 'undefined') {
    try {
      sessionStorage.setItem(EDITOR_RETURN_ROUTE_KEY, routePath);
    } catch { /* ignore */ }
  }
}

export function getEditorReturnRoute() {
  if (memoryEditorReturnRoute) return memoryEditorReturnRoute;
  if (typeof sessionStorage !== 'undefined') {
    try {
      const stored = sessionStorage.getItem(EDITOR_RETURN_ROUTE_KEY);
      if (stored && stored !== '/editor' && !stored.startsWith('/editor?') && !stored.startsWith('/login') && stored !== '/') {
        return stored;
      }
    } catch { /* ignore */ }
  }
  return '';
}

export function clearEditorReturnRoute() {
  memoryEditorReturnRoute = '';
  if (typeof sessionStorage !== 'undefined') {
    try {
      sessionStorage.removeItem(EDITOR_RETURN_ROUTE_KEY);
    } catch { /* ignore */ }
  }
}
